import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

angular
  .module('bringoz.admin.billing-accounts')
  .factory('BillingOrdersAPI', BillingOrdersAPI);

function BillingOrdersAPI(): BringozApi {
  return {
    base: `/billingOrders`,
    infiniteScroll: {
      address: `/billingOrders`,
      cmd: 'GET'
    },
    actions: {
      getPrice: {
        address: '{billingOrderId}/pricing',
        cmd: 'GET',
        updateable: false
      },
      updatePrice: {
        address: '{billingOrderId}/pricing',
        cmd: 'POST',
        updateable: false
      },
      getBillingOrder: {
        address: '{billingOrderId}',
        cmd: 'GET'
      },
      createInvoice: {
        address: 'invoices',
        cmd: 'POST',
        updateable: false
      },
      deleteInvoice: {
        address: '{billingOrderId}/invoice/delete',
        cmd: 'POST',
        updateable: false
      },
      getInvoice: {
        address: '{billingOrderId}/invoice/pdf',
        cmd: 'GET',
        updateable: false
      },
      syncPrice: {
        address: '{billingOrderId}/syncPriceDetails',
        cmd: 'POST',
        updateable: false
      },
      exportCSV: {
        address: 'export',
        cmd: 'POST',
        updateable: false
      },
      manualPaid: {
        address: '{billingOrderId}/manualPaid',
        cmd: 'POST',
        updateable: false
      }
    }
  }
}
